import { Avatar, Button, Collapse, Descriptions, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { signOut, useSession } from 'technical/auth/client';
import { useNavigate } from 'react-router';
import { Routes } from 'business/router/constants';
import { appLocalDataService } from 'ui/user-menu/services/app-local-data';
import { useTranslation } from 'translations/hooks';
import { ScanSite } from './scan-site';
import { MainCard } from 'ui/components/main-card';

import { db } from 'technical/db';

const { Title } = Typography;

export const SessionInfo = () => {
  const { t } = useTranslation();
  const { data: session } = useSession();
  const navigate = useNavigate();

  if (!session) {
    navigate(Routes.App);
    return;
  }

  const handleLogout = async () => {
    appLocalDataService.delete();
    await db.delete();
    await signOut();
    navigate(Routes.App);
  };

  const redirectHome = async () => {
    navigate(Routes.App);
  };

  return (
    <div className="flex w-full flex-col justify-between p-4">
      <div>
        <div className="flex items-center gap-4">
          <Avatar className="bg-primary flex h-12 w-12 items-center justify-center rounded-full">
            <UserOutlined className="text-xl text-white" />
          </Avatar>
          <div>
            <Title level={4} className="mb-0">
              {session.user.name}
            </Title>
          </div>
        </div>

        <Collapse
          ghost
          items={[
            {
              key: '1',
              label: t('settings.details'),
              children: (
                <Descriptions column={1} size="small" bordered>
                  <Descriptions.Item label="Expiration sesion">
                    {new Date(session.session.expiresAt).toLocaleString()}
                  </Descriptions.Item>
                  <Descriptions.Item label="Project">
                    {session.user.projectId}
                  </Descriptions.Item>
                </Descriptions>
              ),
            },
          ]}
        />

        <MainCard>
          <ScanSite />
        </MainCard>

        <div className="flex justify-center py-4">
          <Button danger type="primary" onClick={handleLogout}>
            {t('common.logout')}
          </Button>
        </div>
      </div>

      <div className="flex">
        <Button type="primary" className="w-full" onClick={redirectHome}>
          {t('common.redirectHome')}
        </Button>
      </div>
    </div>
  );
};
